import { ArtManifest } from './types.ts';

let _manifest: ArtManifest | null = null;

export async function loadManifest(): Promise<ArtManifest> {
  if (_manifest) return _manifest;
  const res = await fetch('/assets/character-manifest.json');
  if (!res.ok) throw new Error(`Failed to load art manifest: ${res.status}`);
  _manifest = await res.json() as ArtManifest;
  return _manifest;
}
